import { render, staticRenderFns } from "./Statim.vue?vue&type=template&id=6749554c&"
import script from "./Statim.vue?vue&type=script&lang=js&"
export * from "./Statim.vue?vue&type=script&lang=js&"
import style0 from "./Statim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports